<script lang="ts" module>
  import { createToaster, melt } from '@melt-ui/svelte';
  import { flip } from 'svelte/animate';
  import { fly } from 'svelte/transition';
  import { m as messages } from '$paraglide/messages';

  import CloseSvg from '$lib/assets/icons/close-sml.svg';

  // Example use in target component, note title and color properties are optional
  // <--script lang="ts">
  //   import { addToast } from '$lib/components/toaster/Toaster.svelte'
  //
  //   function create() {
  //     addToast({
  //       data: {
  //         title: 'Success',
  //         description: 'The resource was created!',
  //         state: ToastState.Success
  //       }
  //     })
  //   }
  // </script-->

  // <button on:click={create}> Create </button>

  export type ToastData = {
    title: string;
    description?: string;
    state?: ToastState;
  };

  export enum ToastState {
    Success = 'bg-green-500',
    Failure = 'bg-red-700',
    Warning = 'bg-yellow-500',
  }

  const {
    elements: { content, title, description, close },
    helpers,
    states: { toasts },
    actions: { portal },
  } = createToaster<ToastData>({
    closeDelay: 5000,
    hover: 'pause-all',
  });

  export const addToast = helpers.addToast;
</script>

<!-- Portal defines the element that contains toasts in the global window -->
<div class="fixed right-0 top-0 z-50 m-4 flex flex-col items-end gap-2" use:portal>
  {#each $toasts as { id, data } (id)}
    <div
      class="grid max-w-sm grid-cols-[1fr_auto] rounded-md bg-neutral-800 pb-3 pl-3 pr-2 pt-2 text-white shadow-md {data.state ===
      ToastState.Failure
        ? ToastState.Failure
        : ''}"
      use:melt={$content(id)}
      animate:flip={{ duration: 500 }}
      in:fly={{ duration: 150, x: '100%' }}
      out:fly={{ duration: 150, x: '100%' }}
    >
      <h3 class="self-center pt-1 text-sm font-medium leading-none tracking-wider" use:melt={$title(id)}>
        {data.title}
      </h3>

      <button
        aria-label={messages.closeNotification()}
        class="grid place-items-center self-start"
        use:melt={$close(id)}
      >
        <svg viewBox="0 0 24 24" class="h-6 w-6 fill-white hover:fill-grey-tint-60">
          <use xlink:href="{CloseSvg}#close-sml" />
        </svg>
      </button>
      {#if data.description}
        <p class="col-span-full mt-1 text-sm font-light" use:melt={$description(id)}>
          {data.description}
        </p>
      {/if}
    </div>
  {/each}
</div>
